export * from "./HomePage";
export * from "./LoginPage";
export * from "./AvailableCoursesPage";
export * from "./NewsPage";
export * from "./SignupPage";
export * from "./HelpPage";
export * from "./MyCoursesPage";
export * from "./CoursePage";
export * from "./ModulePage";
export * from "./ManageUsers";
export * from "./ManageCourses";
export * from "./ManagePages";
export * from "./ManageNews";
export * from "./ManageClasses";
export * from "./ManageModules";
export * from "./RecoverPasswordPage";
export * from "./ManageBanners";
export * from "./ManageProducts";
export * from "./ManageNewsletter";
export * from "./NotFoundPage";
